import { retrieveFights } from '../../../../corelogic/state/fight/fight.action';
import { store } from '../../../../corelogic/state/store';

export const FightService = {
  retrieveFights: () => {
    store.dispatch(retrieveFights({ retry: 0 }));
  },
};
